import { Theme } from '@mui/material';

export const Z_INDEX = {
  layers: {
    // Deepest layer e.g bottom gradient in 2 layer gradient on image
    deepBackground: (theme: Theme) => theme.zIndex.appBar - 4,
    // Deeper content gradient in a carousel
    background: (theme: Theme) => theme.zIndex.appBar - 3,
    // Foreground content e.g. text/button above background elements
    foreground: (theme: Theme) => theme.zIndex.appBar - 2,

    // Floating UI controls positioned over content
    // think pagination dots, navigation arrows
    controls: (theme: Theme) => theme.zIndex.appBar - 1,

    // Defer to MUI tokens for overlays
    modal: (theme: Theme) => theme.zIndex.modal,
    snackbar: (theme: Theme) => theme.zIndex.snackbar,
    tooltip: (theme: Theme) => theme.zIndex.tooltip,
  },
} as const;
